import { events } from "aws-amplify/data"; // no public export from aws-amplify
import { fetchAuthSession } from "aws-amplify/auth";

// no public export from aws-amplify
export type EventsChannel = Awaited<ReturnType<typeof events.connect>>;

export const connectChannel = async (
  channelName: string,
): Promise<EventsChannel> => events.connect(channelName);

export const subscribe = async <T>(
  channel: EventsChannel,
  onEvent: (event: T) => void,
  onError?: (err: any) => void,
) => {
  const session = await fetchAuthSession();
  const idToken = session.tokens?.idToken?.toString();

  return channel.subscribe(
    {
      next: (data: any) => {
        if (data?.event) onEvent(data.event as T);
      },
      error: (err: any) => {
        console.error("Subscription error", err);
        onError?.(err);
      },
    },
    {
      authToken: idToken,
    },
  );
};

export const unsubscribe = (
  channel: EventsChannel,
  subscription?: { unsubscribe?: () => void },
) => {
  // is subscription exists, then unsubscribe
  subscription?.unsubscribe?.();
  // close the channel
  channel?.close?.();
};

export async function subscribeToChannel<T>(
  channelName: string,
  onEvent: (event: T) => void,
  onError?: (err: any) => void,
) {
  const channel = await connectChannel(channelName);
  const subscription = await subscribe<T>(channel, onEvent, onError);
  return { channel, subscription };
}
